import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { GlobalState } from "../../GlobalState";
import ToggleButton from "../utils/ToggleButton";
import Button from "../utils/RadioButton.js";
import { editAccess, formatDate } from "../utils/utils";
import { formatOfflineDuration } from "../utils/formatOfflineDuration";

const RippleAnimation = keyframes`
  0% { box-shadow: 0 0 0px 0px rgba(26, 163, 236, 0.6); }
  100% { box-shadow: 0 0 0px 20px rgba(26, 163, 236, 0); }
`;

// const PbBlock = styled.div`
//   position: relative;
//   flex: 0 0 auto;
//   width: fit-content;
//   width: 240px;
//   border-radius: 10px;
//   overflow: hidden;
//   border: 1px solid #e5e7eb;
//   display: flex;
//   transition: all 0.3s ease;

//   @media (max-width: 1024px) {
//     flex: 1 1 calc(50% - 16px);
//     max-width: calc(50% - 16px);
//     min-width: 260px;
//     margin: 0.35rem;
//   }

//   @media (max-width: 480px) {
//     flex: 1 1 100%;
//     max-width: 100%;
//     min-width: 0;
//     margin: 0.3rem 0;
//   }
// `;

const PbBlock = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: fit-content;
  // min-width: 180px;
  // max-width: 340px;
  width: 240px;
  margin: 0.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  display: flex;
  transition: all 0.3s ease;

  @media (max-width: 480px) {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0.3rem 0;
  }
`;

const AccentBar = styled.div`
  width: 5px;
  flex-shrink: 0;
  background: ${({ $isFaulty, $isOnline }) =>
    $isFaulty ? "#F59E0B" : $isOnline ? "#22C55E" : "#94A3B8"};
`;

const PbInner = styled.div`
  flex: 1;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;


const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  ${({ $isFaulty, $isOnline }) =>
    $isFaulty
      ? css`
          filter: hue-rotate(-70deg) saturate(1.4);
        `
      : !$isOnline
      ? css`
          filter: grayscale(1) opacity(0.7);
        `
      : css`
          filter: none;
        `}
`;

const PbMeta = styled.div`
  flex: 1;
  min-width: 0;
`;

// const LocationName = styled.p`
//   margin: 0;
//   font-weight: 700;
//   white-space: wrap;
//   font-size: 0.85rem;
//   min-width: 0;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   cursor: pointer;
//   color: #111827;

//   @media (max-width: 768px) {
//     font-size: 0.75rem;
//   }
// `;

const LocationName = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 0.85rem;
  min-width: 0;
  cursor: pointer;
  color: #111827;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;


const StatusLine = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ $isFaulty, $isOnline }) =>
    $isFaulty ? "#D97706" : $isOnline ? "#16A34A" : "#9CA3AF"};

  @media (max-width: 768px) {
    font-size: 0.65rem;
  }
`;

const Badge = styled.span`
  font-size: 9.5px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ $isFaulty, $isOnline }) =>
    $isFaulty
      ? "rgba(245,158,11,.12)"
      : $isOnline
      ? "rgba(34,197,94,.12)"
      : "#F3F4F6"};
  color: ${({ $isFaulty, $isOnline }) =>
    $isFaulty ? "#B45309" : $isOnline ? "#15803D" : "#090a0e"};
`;

const BadgeStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.08);
  }
`;

const PlainDuration = styled.span`
  display: inline-block; /* Important */
  font-size: 10px;
  font-weight: 500;
  color: #d81111;
  white-space: nowrap;
  animation: ${pulse} 2s infinite ease-in-out;
  transform-origin: center;
`;

const DummyWrapper = styled.div`
  position: absolute;
  z-index: 100;
  top: 0%;
  background-color: transparent;
  width: 60%;
  height: 100%;
  pointer-events: none;
`;

const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
// const ModeRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   flex-shrink: 0;
// `;

// const ModeInline = styled(ModeRow)`
//   display: none;

//   @media (max-width: 768px) {
//     display: flex;
//   }
// `;

const ModeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const ModeStatic = styled(ModeRow)``;

/* Auto/Manual shown in BottomRow, next to HydroSense — only on larger screens */
const ModeDesktop = styled(ModeRow)`
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

const ModeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const ModeLabel = styled.span`
  font-size: 0.7rem;
  color: #374151;
  font-weight: 600;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 0.65rem;
  }
`;

const WaterSenseRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

const WaterSenseLightWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
`;

const WaterSenseLight = styled.div`
  width: 28px;
  height: 14px;
  border-radius: 3px;
  background-color: ${(props) => (props.$isWet ? "#1AA3EC" : "#d9594c")};
  box-shadow: ${(props) =>
    props.$isWet
      ? "0 0 8px rgba(26, 163, 236, 0.5)"
      : "0 0 8px rgba(217, 89, 76, 0.4)"};
  transition: all 0.3s ease;

  ${(props) =>
    props.$isWet &&
    css`
      animation: ${RippleAnimation} 1.5s ease-in-out infinite;
    `}
`;

function toBool(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    return v === "1" || v === "true" || v === "on";
  }
  return Boolean(value);
}

function useTouchTooltip(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let hideTimer;

    const onTouchStart = (e) => {
      e.preventDefault();
      el.classList.add("touch-active");
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
    };

    el.addEventListener("touchstart", onTouchStart, { passive: false });
    return () => {
      el.removeEventListener("touchstart", onTouchStart);
      clearTimeout(hideTimer);
    };
  }, [ref]);
}

export default function PumpStatusV3({ sensor_id, motor_id, isBorewell }) {
  const history = useHistory();
  const location = useLocation();
  const isDetailPage = location.pathname.includes("/motor/");
  const state = useContext(GlobalState);

  const [list, setList] = useState({});
  const [pumpState, setPumpState] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [pumpData, setPumpData] = useState({});
  const [sensorStatus, setSensorStatus] = useState("online");
  const [pumpExist, setPumpExist] = useState(true);

  const borewellTooltipRef = useRef(null);
  useTouchTooltip(borewellTooltipRef);

  const locationName = !pumpData?.motor_status?.location_name
    ? "Borewell"
    : pumpData?.motor_status?.location_name;
  const MAX_LENGTH = 15;
  const truncatedLocationName =
    locationName.length > MAX_LENGTH
      ? locationName.substring(0, MAX_LENGTH)
      : locationName;

  const hasWaterSense = list?.name === "water-sense" && !list?.isDeleted;

  async function togglePumpStatus(motor_id) {
    const previousState = pumpState;
    try {
      setPumpState(!pumpState);
      await axios.get(
        `${process.env.REACT_APP_API}/sensor/v2/toggle_pump_status?motor_id=${motor_id}`,
        { headers: { Authorization: state.token[0] } }
      );
    } catch (err) {
      setPumpState(previousState);
      console.log(err?.response?.data?.message || err.message);
    }
  }

  async function toggleMode(motor_id) {
    const previousMode = isManual;
    try {
      setIsManual(!isManual);
      await axios.get(
        `${process.env.REACT_APP_API}/sensor/borewell/toggle-operation/${motor_id}`,
        { headers: { Authorization: state.token[0] } }
      );
    } catch (err) {
      setIsManual(previousMode);
      console.log(err?.response?.data?.message || err.message);
    }
  }

  async function fetchData(token, motor_id, sensor_id, type) {
    try {
      const pumpStatus = await axios.get(
        `${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
        { headers: { Authorization: token[0] } }
      );

      setPumpData(pumpStatus.data);
      setPumpState(toBool(pumpStatus.data.motor_status.motor_on));
      setSensorStatus(pumpStatus.data.sensor_status);
      setIsManual(toBool(pumpStatus.data.motor_status?.manual_mode));

      const sensorReading = await axios.get(
        `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor_id}&type=${type}`,
        { headers: { Authorization: token[0] } }
      );

      if (sensorReading) {
        setList(sensorReading.data);
      }
    } catch (err) {
      if (err?.response?.status === 404) {
        setPumpExist(false);
      }
      console.log(err?.response?.data?.message || err.message);
    }
  }

  useEffect(() => {
    fetchData(state.token, motor_id, sensor_id, "water-sense");
    const interval = setInterval(() => {
      fetchData(state.token, motor_id, sensor_id, "water-sense");
    }, 5000);
    return () => clearInterval(interval);
  }, [state.token, motor_id, sensor_id]);

  if (!pumpExist) return <></>;

  const isOnline = sensorStatus === "online";
  const isFaulty = sensorStatus === "fault" || sensorStatus === "faulty";
  const waterSenseOnline = list.sensor_status === "online";
  const isWet = toBool(list?.value);

  const statusLabel = isFaulty
    ? "FAULT · check sensor"
    : pumpState
    ? "ON · running"
    : "OFF";

  return (
    <PbBlock>
      <DummyWrapper
        className="test"
        onClick={() => {
          if (!isBorewell) return;
          history.push(`/motor/${motor_id}/sensor/${sensor_id}/Pump - ${locationName}`);
        }}
      />

      <AccentBar $isOnline={isOnline} $isFaulty={isFaulty} />

      <PbInner>
<TopRow>
  {!isDetailPage && (
    <ToggleWrapper $isOnline={isOnline} $isFaulty={isFaulty}>
      <ToggleButton
        disabled={!editAccess(state.userAPI)}
        id={motor_id}
        checked={pumpState}
        onChange={() => togglePumpStatus(motor_id)}
      />
    </ToggleWrapper>
  )}

  <PbMeta>
    <LocationName onClick={() => history.push(`/motor/${motor_id}/sensor/${sensor_id}/Pump - ${locationName}`)}>
      {truncatedLocationName}
    </LocationName>
    <StatusLine $isOnline={isOnline} $isFaulty={isFaulty}>
      {statusLabel}
    </StatusLine>
  </PbMeta>

  <BadgeStack>
    <Badge $isOnline={isOnline} $isFaulty={isFaulty}>
      {isFaulty ? "faulty" : isOnline ? "online" : "offline"}
    </Badge>
    {!isOnline && (
      <PlainDuration>
        {formatOfflineDuration(pumpData?.motor_status?.updatedAt)}
      </PlainDuration>
    )}
  </BadgeStack>
</TopRow>

<BottomRow>
  <ModeRow>
    <ModeWrapper>
      <Button
        id={`${motor_id}-manual`}
        checked={!isManual}
        onChange={() => toggleMode(motor_id)}
        optionLabels={["Auto", "Manual"]}
        small
      />
    </ModeWrapper>
    <ModeLabel>{isManual ? "Manual" : "Auto"}</ModeLabel>
  </ModeRow>

  {hasWaterSense && (
    <WaterSenseRow>
      <WaterSenseLightWrapper
                onClick={() => {
                  history.push(`/sensor/${sensor_id}/Water%20Sense`);
                }}
              >
                <WaterSenseLight $isWet={isWet} />
              </WaterSenseLightWrapper>

              <BadgeStack>
                <Badge $isOnline={waterSenseOnline}>
                  {waterSenseOnline ? "online" : "offline"}
                </Badge>

                {!waterSenseOnline && (
                  <PlainDuration>
                    {formatOfflineDuration(list.date, list.time)}
                  </PlainDuration>
                )}
              </BadgeStack>
    </WaterSenseRow>
  )}
</BottomRow>
      </PbInner>
    </PbBlock>
  );
}
